import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Icons } from "../../../config/MuiIcons.config";
import AppButton from "../../../components/CommonReusableComponent/AppButton/AppButton";
import WarningImage from "../../../assets/images/Warning.svg";

const WarningModalForActivityDelete = ({
  Open,
  ToggleFunction,
  OnSubmit,
  Data,
}) => {

  const { action, id, obj } = Data;  

  const handleClose = () => {
    ToggleFunction();
  };

  return (
    <React.Fragment>
      <Dialog
        open={Open}
        aria-labelledby="form-dialog-title"
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle style={{ textAlign: "center" }}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <Icons.Close />
          </IconButton>
          <img
            src={WarningImage}
            alt="warning-img"
            style={{ width: "45px", height: "45px" }}
          />
        </DialogTitle>
        <DialogContent style={{ textAlign: "center" }}>
          <Typography
            style={{ fontSize: "24px" }}
            className="inter-regular-400"
          >
            Are you sure?
          </Typography>
          <Typography
            className="inter-regular-400"
            style={{ fontSize: "16px" }}
          >
            Do you want to delete this activity
          </Typography>
        </DialogContent>
        <DialogActions className="justify-content-center mb-3 mx-5">
          <AppButton OnPress={handleClose}>Cancel</AppButton>
          <AppButton
            Color={"error"}
            OnPress={() => {
              OnSubmit(action, id, obj);
              handleClose();
            }}
          >
            Delete
          </AppButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default WarningModalForActivityDelete;
